import {
  DOCUMENT_GROUP_FAILED,
  DOCUMENT_GROUP_FETCHING,
  DOCUMENT_GROUP_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case DOCUMENT_GROUP_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case DOCUMENT_GROUP_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case DOCUMENT_GROUP_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
